/* Infless: kleine mechanics bovenop het July-thema. Alles is progressief: zonder JS blijft de pagina volledig zichtbaar. */
(function () {
  var d = document;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  // 1. Secties op de homepage schuiven rustig in zodra ze in beeld komen (hero uitgezonderd).
  if (!reduced && !designMode && 'IntersectionObserver' in window && d.body.classList.contains('template-index')) {
    var sections = Array.prototype.slice.call(d.querySelectorAll('main .shopify-section'));
    var targets = sections.filter(function (s) { return !s.querySelector('.image-banner-section'); });
    if (targets.length) {
      d.body.classList.add('ifl-anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ifl-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -6% 0px' });
      targets.forEach(function (t) { t.classList.add('ifl-reveal'); io.observe(t); });
      // Veiligheidsnet: na 2,5 s alles tonen, ook als een observer niet vuurt.
      setTimeout(function () { targets.forEach(function (t) { t.classList.add('ifl-in'); }); }, 2500);
    }
  }

  // 2. Foto's in de Infless-secties faden zacht in zodra ze geladen zijn.
  var imgs = Array.prototype.slice.call(d.querySelectorAll('.ifl-zoom img, .ifl-voordeel__img, .ifl-verhaal__img'));
  if (imgs.length && !reduced) {
    d.body.classList.add('ifl-fade');
    imgs.forEach(function (img) {
      var done = function () { img.classList.add('ifl-img-in'); };
      if (img.complete && img.naturalWidth > 0) { done(); }
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
    // Veiligheidsnet: na 4 s alles tonen.
    setTimeout(function () { imgs.forEach(function (img) { img.classList.add('ifl-img-in'); }); }, 4000);
  }

  // 3. Schaduw onder de header zodra de pagina gescrold is.
  var header = d.querySelector('header-component');
  if (header) {
    var onScroll = function () { header.classList.toggle('ifl-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();